import { StepActiveIcon } from '@p2p/assets/svg';
import { Typography } from '@p2p/components';
import cn from 'classnames';
import type { PropsWithChildren } from 'react';

import styles from './Section.module.scss';

type SectionProps = PropsWithChildren<{
  className?: string;
  title: string;
  logo: string;
  active?: boolean;
  checked?: boolean;
}>;

export const Section = ({ children, className, title, logo, active, checked }: SectionProps) => {
  return (
    <div
      className={cn(styles.section, className, {
        [styles.inactive]: !active,
        [styles.checked]: checked,
      })}
    >
      <div className={styles.leftBlock}>
        <img src={logo} alt="logo" className={styles.logo} />
        <Typography variant="text-m-bold" color="heading" className={styles.title}>
          {title}
        </Typography>
      </div>
      <div className={styles.divider} />
      <div className={styles.rightBlock}>{children}</div>
      {!active && <div className={styles.overlay} />}
      {checked && <StepActiveIcon className={styles.checkedIcon} />}
    </div>
  );
};
